import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { Map } from 'immutable';
import { ALL_USERS } from "../../constants.js";
import { formatDataIntoRow } from "../../util/outcomesReportUtils.js";
function restrict(state, scope) {
  return state.getIn([scope, 'report']) || Map();
}
export function getPageCount(state, scope) {
  if (state) {
    var pageData = restrict(state, scope).get('pageData');
    if (pageData) {
      var _pageData$toJS = pageData.toJS(),
        total = _pageData$toJS.total,
        perPage = _pageData$toJS.perPage;
      return Math.ceil(total / perPage);
    }
  }
  return null;
}
export function getLoading(state, scope) {
  return state && restrict(state, scope).get('loading');
}
export function getLoadingRemainingPages(state, scope) {
  return state && restrict(state, scope).get('loadingRemainingPages');
}
export function getPageNumber(state, scope) {
  return state && restrict(state, scope).getIn(['page', 'number']);
}
export function getPageLoading(state, scope) {
  return state && restrict(state, scope).getIn(['page', 'loading'], false);
}
export function getUsers(state, scope, pageNumber) {
  return pageNumber == ALL_USERS ? getAllUsers(state, scope) : getUsersForPage(state, scope, pageNumber);
}
export function getHighestPageSeen(state, scope) {
  var seenPages = state && restrict(state, scope).get('users');
  var pagesList = seenPages && _toConsumableArray(seenPages.keys()).map(function (pageNumber) {
    return parseInt(pageNumber);
  });
  return pagesList ? Math.max.apply(Math, _toConsumableArray(pagesList)) : 0;
}
export function getRollups(state, scope) {
  var rollups = state && restrict(state, scope).get('rollups');
  return rollups ? rollups.toJS() : [];
}
export function getScore(state, scope, outcomeId, userId) {
  var score = state && restrict(state, scope).getIn(['results', outcomeId, userId]);
  return score ? score.toJS() : null;
}
export function getResults(state, scope, outcomeId) {
  var results = state && restrict(state, scope).getIn(['results', outcomeId]);
  return results ? results : Map();
}
export function isOpen(state, scope, outcomeId) {
  return restrict(state, scope).get('openReportAlignmentId') === outcomeId;
}
export function getReportOutcome(state, scope, outcomeId) {
  var outcome = restrict(state, scope).getIn(['outcomes', outcomeId]);
  return outcome ? outcome.toJS() : null;
}
export function hasAnyOutcomes(state, scope) {
  return state && restrict(state, scope).getIn(['outcomes']).size > 0;
}
export function formatCSVData(state, scope) {
  var rows = [];
  var users = Object.values(getAllUsers(state, scope)).flat();
  var rollups = getRollups(state, scope);
  users.forEach(function (user) {
    rollups.forEach(function (rollup) {
      var outcome = getReportOutcome(state, scope, rollup.outcomeId);
      var result = getScore(state, scope, rollup.outcomeId, user.uuid);
      if (result) {
        var row = formatDataIntoRow(user, outcome, rollup, result);
        rows.push(row);
      }
    });
  });
  return rows;
}

// Helpers

var getAllUsers = function getAllUsers(state, scope) {
  var allUsers = state && restrict(state, scope).get('users');
  return allUsers ? allUsers.toJS() : {};
};
var getUsersForPage = function getUsersForPage(state, scope, pageNumber) {
  var users = pageNumber != void 0 && state && restrict(state, scope).getIn(['users', pageNumber.toString()]);
  return users ? users.toJS() : [];
};